import script from "./EducationSkill.vue?vue&type=script&lang=ts&setup=true"
export * from "./EducationSkill.vue?vue&type=script&lang=ts&setup=true"

import "./EducationSkill.vue?vue&type=style&index=0&id=f9003c06&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9003c06"]])

export default __exports__